import { memo } from 'react';
import { TabPanel as RACTabPanel, TabPanelProps as RACTabPanelProps } from 'react-aria-components';

import { merge } from '@/components';

export type TabPanelProps = RACTabPanelProps;

const ITabPanel = ({ className, children, ...rest }: TabPanelProps) => {
  return (
    <RACTabPanel className={merge(className)} {...rest}>
      {children}
    </RACTabPanel>
  );
};

export const TabPanel = memo(ITabPanel) as typeof ITabPanel;
